import { render, staticRenderFns } from "./SampleGroupDetail.vue?vue&type=template&id=816ec7e2&scoped=true"
import script from "./SampleGroupDetail.vue?vue&type=script&lang=js"
export * from "./SampleGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./SampleGroupDetail.vue?vue&type=style&index=0&id=816ec7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816ec7e2",
  null
  
)

export default component.exports